import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../common/header";
import Footer from "../common/footer";

const Layout = ({ children }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // Hide Header/Footer for register tab and forgot password page
  const hideLayout =
    (location.pathname === "/auth" && searchParams.get("tab") === "register") ||
    location.pathname === "/forgot-password" || location.pathname === "/";

  return (
    <>
      {!hideLayout && <Header />}
      {children}
      {!hideLayout && <Footer />}
    </>
  );
};

export default Layout;